import I18n from 'I18n';
import styled, { css } from 'styled-components';
import { NEUTRAL_1600 } from 'visitor-ui-component-library/constants/WidgetColors';
import SVGKnowledgeBase from 'visitor-ui-component-library-icons/icons/SVGKnowledgeBase';
import SVGWebsite from 'visitor-ui-component-library-icons/icons/SVGWebsite';
import { useWidgetModalOrContext } from '../widget-modal/WidgetModalContext';
import { isSafeLink } from '../utils/isSafeLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TEXT_COLOR = NEUTRAL_1600;
const CitationHeaderWrapper = styled.div.withConfig({
  displayName: "CitationModalContent__CitationHeaderWrapper"
})(["flex:1;color:", ";font-size:12px;"], TEXT_COLOR);
const ContentSourceType = styled.div.withConfig({
  displayName: "CitationModalContent__ContentSourceType"
})(["display:flex;align-items:center;margin:4px 0;"]);
const iconBaseStyles = css(["fill:", ";font-size:16px;margin-right:4px;"], TEXT_COLOR);
const WebsiteIcon = styled(SVGWebsite).withConfig({
  displayName: "CitationModalContent__WebsiteIcon"
})(["", ""], iconBaseStyles);
const KnowledgeBaseIcon = styled(SVGKnowledgeBase).withConfig({
  displayName: "CitationModalContent__KnowledgeBaseIcon"
})(["", ""], iconBaseStyles);
const citationLinkBaseStyles = css(["text-decoration:none;font-size:12px;line-height:18px;font-weight:600;&:hover{text-decoration:underline;}"]);
const CitationLink = styled.a.withConfig({
  displayName: "CitationModalContent__CitationLink"
})(["", " color:", ";"], citationLinkBaseStyles, ({
  $accentColor
}) => $accentColor);
const CitationButton = styled.button.withConfig({
  displayName: "CitationModalContent__CitationButton"
})(["", " color:", ";border:none;padding:0;background-color:transparent;cursor:pointer;"], citationLinkBaseStyles, ({
  $accentColor
}) => $accentColor);
const CitationButtonAsLink = ({
  accentColor,
  children,
  navigateToKnowledgeBaseArticle,
  source
}) => {
  const {
    closeModal
  } = useWidgetModalOrContext();
  const handleClick = () => {
    navigateToKnowledgeBaseArticle({
      deepLink: source.deepLink,
      hubSpotContentId: source.hubSpotContentId,
      hubSpotContentTextFragment: source.hubSpotContentTextFragment
    });
    closeModal();
  };
  return /*#__PURE__*/_jsx(CitationButton, {
    $accentColor: accentColor,
    onClick: handleClick,
    children: children || I18n.text('conversations-visitor-message-history.viewSource')
  });
};
CitationButtonAsLink.displayName = 'CitationButtonAsLink';
const CitationHeader = ({
  source
}) => {
  const {
    hubSpotContentType
  } = source;
  const isKbArticle = hubSpotContentType === 'KB_ARTICLE';
  const icon = isKbArticle ? /*#__PURE__*/_jsx(KnowledgeBaseIcon, {}) : /*#__PURE__*/_jsx(WebsiteIcon, {});
  const text = isKbArticle ? I18n.text('conversations-visitor-message-history.knowledgeBase') : I18n.text('conversations-visitor-message-history.website.singular');
  return /*#__PURE__*/_jsx(CitationHeaderWrapper, {
    children: /*#__PURE__*/_jsxs(ContentSourceType, {
      children: [icon, /*#__PURE__*/_jsx("p", {
        children: text
      })]
    })
  });
};
CitationHeader.displayName = 'CitationHeader';
const CitationBody = ({
  accentColor,
  navigateToKnowledgeBaseArticle,
  source
}) => {
  const {
    deepLink,
    hubSpotContentType,
    title,
    url
  } = source;
  const isKbArticle = hubSpotContentType === 'KB_ARTICLE';
  const link = isKbArticle && navigateToKnowledgeBaseArticle ? /*#__PURE__*/_jsx(CitationButtonAsLink, {
    accentColor: accentColor,
    source: source,
    navigateToKnowledgeBaseArticle: navigateToKnowledgeBaseArticle,
    children: title
  }) : /*#__PURE__*/_jsx(CitationLink, {
    $accentColor: accentColor,
    href: isSafeLink(deepLink) ? deepLink : undefined,
    target: "_blank",
    rel: "noopener noreferrer",
    children: url
  });
  return link;
};
CitationBody.displayName = 'CitationBody';
export const CitationModalContent = ({
  accentColor,
  navigateToKnowledgeBaseArticle,
  source
}) => {
  return {
    headerContent: /*#__PURE__*/_jsx(CitationHeader, {
      source: source
    }),
    bodyContent: /*#__PURE__*/_jsx(CitationBody, {
      accentColor: accentColor,
      navigateToKnowledgeBaseArticle: navigateToKnowledgeBaseArticle,
      source: source
    }),
    colorOverrides: {}
  };
};
CitationModalContent.displayName = 'CitationModalContent';